import {AxiosResponse} from 'axios'
import {
  GetShadowFinderUserLoginsResponse,
  GetShadowITAppUsersRes,
  ShadowITAppTab,
  ShadowITLoginType,
  ShadowITOverviewLoginsResponse,
} from 'interfaces'
import {unwrapAPIError} from 'utils'
import {getShadowBaseUrl, requestHandler} from '../HTTP'
import {HttpMethods} from '../HTTP/HTTP.types'

const shadowFinderBaseUrl = getShadowBaseUrl()

const getShadowUserLogins = async (
  email: string,
): Promise<AxiosResponse<GetShadowFinderUserLoginsResponse>> => {
  try {
    return await requestHandler<GetShadowFinderUserLoginsResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${shadowFinderBaseUrl}/users/${email}/logins`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getShadowAppLogins = async (
  appName: string,
  endCursor: string,
  currentTab: ShadowITAppTab,
  includeSummary: boolean = false,
  searchType?: string,
  searchTerm?: string,
  first: number = 50,
): Promise<AxiosResponse<GetShadowITAppUsersRes>> => {
  try {
    const params = {
      after: endCursor,
      first,
    }
    if (searchType) {
      params[searchType] = searchTerm
    }
    if (includeSummary) params['includeSummary'] = true
    if (currentTab !== 'all') {
      const loginType: ShadowITLoginType =
        currentTab === 'corporate' ? 'accepted' : 'unaccepted'
      params['loginType'] = loginType
    }
    return await requestHandler<GetShadowITAppUsersRes>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${shadowFinderBaseUrl}/apps/${appName}/logins`,
      options: {
        params,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getShadowITOverviewLogins = async (
  searchType?: string,
  searchTerm?: string,
): Promise<AxiosResponse<ShadowITOverviewLoginsResponse>> => {
  const params = {}
  if (searchType) {
    params[searchType] = searchTerm
  }
  try {
    return await requestHandler<ShadowITOverviewLoginsResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${shadowFinderBaseUrl}/overview`,
      options: {
        params,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const ShadowFinderService = {
  getShadowUserLogins,
  getShadowAppLogins,
  getShadowITOverviewLogins,
}
